<template>
  <!-- Modal -->
  <div class="modal" id="overlay" v-show="showModalFlg">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content" id="content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
          エラー確認画面
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="close">
            <span @click="closeModal">&times;</span>
           </button>
        </div>
      <div class="modal-body2" style="overflow-x:auto;">
        <table id="data-table" class="table table-striped table-hover">
          <thead>
            <tr>
              <th scope="col">エラー行</th>
              <th scope="col">エラー項目</th>
              <th scope="col">設定値</th>
              <th scope="col">エラー内容</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value,index) in inventoryFileErrorList" :key="index">
              <td class="table-cell-wrap mw100 mxw100">{{ value.errorLineNumber === 0 ? '' : value.errorLineNumber }}</td>
              <td class="table-cell-wrap mw200 mxw200">{{ value.errorItem }}</td>
              <td class="table-cell-wrap mw300 mxw300">{{ value.errorItemValue }}</td>
              <td class="table-cell-wrap mw300 mxw300">{{ value.errorMessage }}</td>
            </tr>
          </tbody>
        </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'inventory-target-file-error-detail',
  components: {},
  showModalFlg: false,
  props: {
    inventoryFileErrorList: {
      type: Array,
      default: null
    },
    showErrorModal: Boolean
  },
  data () {
    return {
      showModalFlg: this.showErrorModal
    }
  },
  methods: {
    isRequired (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === ''
    },
    closeModal () {
      this.$emit('closeModal')
    }
  },
  watch: {
    showErrorModal (value) {
      this.showModalFlg = value
    }
  },
  computed: {
    setShowModalFlg () {
      return this.showModalFlg
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/InvetoryTargetFileErrorDetail.vue